import * as types from '../mutation-types'
import Http from 'utils/http'

export const allWhatNow = ({ dispatch }) => {
	return Http.get('what-now').then(response => {
		let whatNow = {};

		for (let i = 0; i < response.body.data.length; ++i) {
			whatNow[response.body.data[i].name] = response.body.data[i].value;
		}

		dispatch(types.SET_WHAT_NOW, whatNow);
	});
}

export const updateWhatNow = ({ dispatch }, name, value) => {
	return Http.put(`what-now/${name}`, { name, value });
}

/**
 * Yeast Type Actions
 */
export const allYeastTypes = ({ dispatch }) => {
	return Http.get('yeast-types').then(response => {
		dispatch(types.SET_YEAST_TYPES, response.body.data || []);
	});
}

export const storeYeastType = ({ dispatch }, name) => {
	return Http.post('yeast-types', { name }).then(response => {
		dispatch(types.ADD_YEAST_TYPE, response.body.data);
	});
}

export const destroyYeastType = ({ dispatch }, id) => {
	return Http.destroy(`yeast-types/${id}`).then(response => {
		dispatch(types.DESTROY_YEAST_TYPE, id);
	})
}

export const editYeastType = ({ dispatch }, id, name) => {
	return Http.put(`yeast-types/${id}`, { name }).then(response => {
		dispatch(types.UPDATE_YEAST_TYPE, id, response.body.data);

		return response;
	});
}

/**
 * Region Actions
 */
export const allRegions = ({ dispatch }, country = { country_id: null }) => {
	return Http.get('regions', country).then(response => {
		dispatch(types.SET_REGIONS, response.body.data || []);
	});
}

export const storeRegion = ({ dispatch }, name, country_id = null) => {
	return Http.post('regions', { name, country_id }).then(response => {
		dispatch(types.ADD_REGION, response.body.data);
	});
}

export const destroyRegion = ({ dispatch }, id) => {
	return Http.destroy(`regions/${id}`).then(response => {
		dispatch(types.DESTROY_REGION, id);
	})
}

export const editRegion = ({ dispatch }, id, name) => {
	return Http.put(`regions/${id}`, { name }).then(response => {
		dispatch(types.UPDATE_REGION, id, response.body.data);

		return response;
	});
}

/**
 * Varietal Actions
 */
export const allVarietals = ({ dispatch }) => {
	return Http.get('varietals').then(response => {
		dispatch(types.SET_VARIETALS, response.body.data || []);
	});
}

export const storeVarietal = ({ dispatch }, name) => {
	return Http.post('varietals', { name }).then(response => {
		dispatch(types.ADD_VARIETAL, response.body.data);
	});
}

export const destroyVarietal = ({ dispatch }, id) => {
	return Http.destroy(`varietals/${id}`).then(response => {
		dispatch(types.DESTROY_VARIETAL, id);
	})
}

export const editVarietal = ({ dispatch }, id, name) => {
	return Http.put(`varietals/${id}`, { name }).then(response => {
		dispatch(types.UPDATE_VARIETAL, id, response.body.data);

		return response;
	});
}

/**
 * Country Actions
 */
export const allCountries = ({ dispatch }) => {
	return Http.get('countries').then(response => {
		dispatch(types.SET_COUNTRIES, response.body || []);
	});
}



// WEBPACK FOOTER //
// ./src/vuex/actions/settings.js